// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__edhsp","clinicsSelect":"styles_clinicsSelect__20XJg"};